<template>
  <a-card class="yl_contact" title="Facebook官方认可代理商" :bordered="false">
    <div class="yl_qrcode">
      <!-- <img src="../../assets/images/yl_qrcode.png" alt="" /> -->
      <div id="wl-qrcode2"></div>
    </div>
    <p>添加企业微信，为您提供1对1的专业解答</p>
    <!-- <a-button type="primary" class="contact_btn" size="large" block>联系咨询</a-button> -->
  </a-card>
</template>

<script>
export default {
  name: 'ContactYL',
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.yl_contact {
  margin-bottom: 20px;

  .yl_qrcode {
    width: 140px;
    height: 140px;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }

  p {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
    margin-top: 16px;
    margin-bottom: 0;
  }
}
</style>
